import { render, staticRenderFns } from "./DefaultSidebar.vue?vue&type=template&id=6c81d432"
import script from "./DefaultSidebar.vue?vue&type=script&lang=ts"
export * from "./DefaultSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports